import * as React from 'react';
import { EmailInfo } from '../../../types';
import './Header.css';

export interface HeaderProps {
  emailInfo: EmailInfo | null;
  isOutgoingEmail: boolean;
}

const Header: React.FC<HeaderProps> = ({ emailInfo, isOutgoingEmail }) => {
  return (
    <header className="header">
      <h1 className="header-title">
        <span className="material-icons-round header-icon">link</span>
        E-mail aan klant koppelen
      </h1>
      <div className="header-right">
        {emailInfo && (
          <div className={`email-type-indicator ${isOutgoingEmail ? 'email-type-indicator--outgoing' : 'email-type-indicator--incoming'}`}>
            <span className="material-icons-round email-type-indicator__icon">
              {isOutgoingEmail ? 'send' : 'inbox'}
            </span>
            <span className="email-type-indicator__label">
              {isOutgoingEmail ? 'Verzonden' : 'Ontvangen'}
            </span>
          </div>
        )}
        <div className="brand-logo">
          <img
            src="https://lh3.googleusercontent.com/aida-public/AB6AXuA3r7oODoRznHNC2WWeuXzh8RiulKbj_P_YJxI8PWLWFfIPWeZ1k2_NsHZRGejL14CPEasPuT4bmgeqI8sp0l4m-26buRJEL-tGEqiOGIRw39Z_xZ6OhrVjJZ-6hgINkzOPv6rJNNjXwEDJAZi0g-8WHdA7p0EOulybFGKfhrNoyfHqn8Agcnhk1qxlAysNOTFiKmqhBYzX4zjspRSnTci0-6PmjHAf7541GBzp1EOd1LkuibiHuhAnVZ_sGUtQPTvO-9PBpr02IaSs"
            alt="Brand Logo"
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
